
'use client';

import { useEffect, useRef } from 'react';

const partners = [
  { name: 'Axis Bank', src: 'images/partners/axis.jpg' },
  { name: 'Bandhan Bank', src: 'images/partners/bandhan.jpg' },
  { name: 'Bank of Baroda', src: 'images/partners/bob.jpg' },
  { name: 'Bank of India', src: 'images/partners/boi.jpg' },
  { name: 'Google Pay', src: 'images/partners/gpay.jpg' },
  { name: 'Mastercard', src: 'images/partners/mastercard.jpg' },
  { name: 'MobiKwik', src: 'images/partners/mobikwik.jpg' },
  { name: 'PayPal', src: 'images/partners/paypal.jpg' },
  { name: 'PhonePe', src: 'images/partners/phonepay.jpg' },
  { name: 'PNB', src: 'images/partners/pnb.jpg' },
  { name: 'Razorpay', src: 'images/partners/razorpay.jpg' },
  { name: 'Stripe', src: 'images/partners/stripe.jpg' },
  { name: 'HDFC Bank', src: 'images/partners/hdfc.jpg' },
  { name: 'ICICI Bank', src: 'images/partners/icici.jpg' },
  { name: 'IDFC First Bank', src: 'images/partners/idfc.jpg' },
  { name: 'Paytm', src: 'images/partners/paytm.jpg' },
  { name: 'SBI', src: 'images/partners/sbi.jpg' },
];

export function PartnerLogos() {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    let animId: number;
    let pos = 0;
    
    // Slowed down slightly for better reading on mobile
    const speed = 0.4; 
    
    const step = () => {
      pos += speed;
      if (pos >= el.scrollWidth / 2) pos = 0;
      el.scrollLeft = pos;
      animId = requestAnimationFrame(step);
    };
    animId = requestAnimationFrame(step);
    el.addEventListener('mouseenter', () => cancelAnimationFrame(animId));
    el.addEventListener('mouseleave', () => { animId = requestAnimationFrame(step); });
    return () => cancelAnimationFrame(animId);
  }, []);

  return (
    <section className="bg-slate-50 py-8 md:py-12 border-t border-slate-100">
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-12 overflow-hidden">

        <div className="text-center mb-6 md:mb-8">
          <p className="text-slate-400 text-[10px] sm:text-xs font-semibold tracking-[0.2em] uppercase">
            OUR PARTNERS
          </p>
        </div>

        {/* Scrolling logos */}
        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-8 overflow-hidden select-none"
          style={{ scrollBehavior: 'unset' }}
        >
          {/* Duplicated array for seamless infinite scrolling */}
          {[...partners, ...partners].map((p, i) => (
            <div
              key={i}
              className="flex-shrink-0 flex items-center justify-center w-28 h-16 md:w-36 md:h-20 rounded-lg md:rounded-xl border border-slate-100 shadow-sm hover:border-amber-200 hover:shadow-md transition-all duration-200 cursor-default"
            >
              <img 
                src={p.src} 
                alt={p.name} 
                title={p.name}
                className="w-full h-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
